const Style = {

  plans: 'block, mb-4',
  plan: 'align-top mb-5 md:inline-block md:mr-4 md:px-8 pr-4 last:mr-0',
  name: 'absolute font-semibold text-center font-sm text-brand-500 uppercase md:relative md:text-slate-500',
  price: 'absolute text-brand-500 font-bold text-lg right-4 top-5 md:relative md:text-3xl md:top-auto md:right-auto md:mt-4',
  features: 'columns-2 ml-0 mt-10 mb-5 md:columns-auto md:mt-4'
  
}

export default Style;